import {
	Menu,
	IMenuItem
} from 'sharebase/domain';

require('./cardList.styles');
const template = require('./cardList.template');

export interface CardConfig {
	hasAvatar:boolean;
	maxHeight:number;
	virtualize:boolean;
}

export interface Card<T> {
	icon:string;
	header:Header;
	body:Body;
	menu:Menu;
	source:T;
	isDisabled:boolean;
	trigger?:() => void;
}

interface Header {
	text:string;
	subtext?:string;
}
interface Body {
	text:string;
	subtext?:string;
}
interface CardsEmptyState {
	icon:string;
	text:string;
	subtext?:string;
}

interface CardListScope<T> extends ng.IScope {
	vm:CardList<T>;
}

export abstract class CardList<T> implements ng.IOnInit {
	constructor(
		private $scope:ng.IScope
	){}

	public source:T[];
	public config:CardConfig;
	public cards:Card<T>[];
	public actions:IMenuItem[];
	public abstract transform:(source:T, actions?:IMenuItem[]) => Card<T>;
	public emptyState:CardsEmptyState;

	public $onInit() {
		this.$scope.$watch('vm.source', (newVal:T[], oldVal:T[], scope:CardListScope<T>) => {
			if (newVal) {
				scope.vm.cards = newVal.map(i => scope.vm.transform(i, scope.vm.actions));
			}
		}, true);
	}
}

export class ShareBaseCardList<T> extends CardList<T> implements ng.IComponentController {
	public static $inject = [
		'$scope'
	];

	public transformSource:(source:T, actions?:IMenuItem[]) => Card<T>;

	constructor(
		$scope:ng.IScope
	) {
		super($scope);
	}

	public transform = (source:T, actions?:IMenuItem[]) => {
		return this.transformSource(source, actions);
	};
}

export const ShareBaseCardListComponent:ng.IComponentOptions = {
	template: template,
	controller: ShareBaseCardList,
	controllerAs: 'vm',
	bindings: {
		source: '<',
		config: '<',
		actions: '<',
		transformSource: '<transform',
		emptyState: '<'
	}
}



// WEBPACK FOOTER //
// ./src/sharebase/components/cardList/cardList.ts